import { Form, FormProps } from "@/components/form";
import { CuentaCorrienteItemTipo } from "@/shared/types/cuenta-corriente";
import { z } from "zod/v4";

export const addCuentaCorrienteItemFormSchema = z.object({
    tipo: z.number({ message: "Este campo es requerido" }).default(CuentaCorrienteItemTipo.Miscelaneo),
    descripcion: z.string(),
    debe: z.number({ message: "Este campo es requerido" }).min(0, "El valor debe ser positivo").or(z.literal("")).transform(v=>Number(v)),
    haber: z.number({ message: "Este campo es requerido" }).min(0, "El valor debe ser positivo").or(z.literal("")).transform(v=>Number(v))
}).refine(v => v.debe != 0 || v.haber != 0, { message: "Ambos debe y haber no pueden ser 0", path: ["form"] })

export default function AddCuentaCorrienteItemForm({
    form,
    ...props
}: FormProps<z.input<typeof addCuentaCorrienteItemFormSchema>>) {
    return <Form form={form} gap={3} {...props}>
        <Form.Select name="tipo" label="Tipo">
            <Form.Select.Option value={CuentaCorrienteItemTipo.Miscelaneo}>Miscelaneo</Form.Select.Option>
            <Form.Select.Option value={CuentaCorrienteItemTipo.Cliente}>Cliente</Form.Select.Option>
            <Form.Select.Option value={CuentaCorrienteItemTipo.Proveedor}>Proveedor</Form.Select.Option>
            <Form.Select.Option value={CuentaCorrienteItemTipo.Vendedor}>Vendedor</Form.Select.Option>
        </Form.Select>
        <Form.MonedaField name="debe" label="Debe" />
        <Form.MonedaField name="haber" label="Haber" />
        <Form.TextField name="descripcion" label="Descripcion" multiline rows={4} />
        <Form.SubmitButton>
            Guardar
            <Form.ErrorText name="form" />
        </Form.SubmitButton>
    </Form>
}